<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
  computed: {
    companyInfo() {
      const { user, companies } = this.$store.getters
      if (user.title) return { title: user.title }
      const company = companies.find(o => +o.id === +this.companyId)

      if (!company) return { title: '' }
      return company
    }
  },
  mounted() {},
  methods: {},
  watch: {
    companyInfo(c) {
      if (c) {
        const logo = this.$store.getters.logo
        const domain = logo.title || logo.name || '农林虫情预警平台'
        document.title = `${domain} | ${c.title}`
      }
    }
  }
}
</script>
